/**
 * Єдина точка читання середовища для logger-а (ADR-0011 D8). Винесено в окремий
 * модуль навмисно: поріг рівня читається на момент виклику, а `isDev()` через
 * окремий експорт лишається стабабельним у юніт-тестах (`vi.spyOn(env, 'isDev')`),
 * незалежно від того, чи vitest проксує `import.meta.env.DEV`.
 */
export function isDev(): boolean {
  return import.meta.env.DEV;
}
